export const NotFound = 'Not_Found';
export const Employee = 'Employee';
export const OresundGo = 'OresundGO';
export const OresundPendler = 'OresundPendler';
export const OresundBusinessPendler = 'Oresund_Business_Pendler';
export const OresundBusiness = 'Oresund_Business';
export const OresundPAY = 'OresundPAY';
export const OresundPAYBusiness = 'OresundPAYBusiness';
export const BroBizzPrivate = 'BroBizz_Private';
export const BroBizzBusiness = 'BroBizz_Business';
export const Storebelt = 'Storebelt';
export const OnlineTicket = 'OnlineTicket';
export const DayTicket = 'DayTicket';
export const WeekendTicket = 'WeekendTicket';
export const KmToll = 'KmToll';
